import { render, staticRenderFns } from "./ListaComplementoPago.vue?vue&type=template&id=1a4d6a71&"
import script from "./ListaComplementoPago.vue?vue&type=script&lang=js&"
export * from "./ListaComplementoPago.vue?vue&type=script&lang=js&"
import style0 from "./ListaComplementoPago.vue?vue&type=style&index=0&id=1a4d6a71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports